var locale = {
  placeholder: 'Уақытты таңдауыңызды сұраймын',
}

export default locale
